var exports = {
  "i": "xaee3c4fa--057c23--wrapper",
};

module.exports = exports;
